export const blueMscLabel = {
  init(destination) {
    // Set the static logo visibility
    if ($(destination.item).hasClass('js-blue-msc-label')) {
      // $('#staticAboutMscLogo').removeClass('js-animate-completed');
    } else {
      // $('#staticAboutMscLogo').addClass('js-animate-completed');
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/featured/sustainability/modules/blueMscLabel.js